<div id="export-button-wrapper" (mouseenter)="openExportOptions(true)" (mouseleave)="openExportOptions(false)">
  <button class="exportButton" id="exportBtn" mat-raised-button color="primary">Export</button>
  <div id="export-menu" *ngIf="showOptions" (click)="deactivateShowOptions()">
    <div class="export-option" (click)="openPageExport()">Export Page</div>
    <div [ngClass]="multiProviderExportEnabled ? 'export-option' : 'export-option-disabled'"
       (mouseenter)="toggleShowHover(true)" (mouseleave)="toggleShowHover(false)"
       (click)="openMultiProviderExport()"><span id="hover-message" *ngIf="!multiProviderExportEnabled && canShowHoverMessage">
    Please select providers from a single department to use Multi Provider Export</span>Multi Provider Export</div>
  </div>
</div>
